import localized from "../locale/locales";

import MainLayout from "../components/layouts/MainLayout";
import Hero from "../components/Hero";
import SectionSteps from "../components/sections/SectionSteps";
import SectionRegisterCta from "../components/sections/SectionRegisterCta";
import imageHeroDesktop from "../public/img/hero/process_desktop.jpg";
import imageHeroMobile from "../public/img/hero/process_mobile.jpg";
import SectionFloating from "../components/sections/SectionFloating";
import {generateTitle} from "../helpers/meta";
import Head from "next/head";
import {useRouter} from "next/router";
import Title from "../components/Title";

export default function HowItWorks() {
    const {locale} = useRouter();
    const {howItWorks: lang} = localized[locale];

    return (
        <MainLayout>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
            </Head>

            <SectionFloating scheme="how-it-works"/>

            <Hero direction="image-right"
                  imageDesktop={imageHeroDesktop}
                  imageMobile={imageHeroMobile}
                  className="relative items-end gap-6 md:gap-10 md:pt-5 pb-16 md:pb-36"
            >
                <div className="flex flex-col gap-7 md:gap-5 md:pb-10 accent-green-800">
                    <div className="flex flex-col gap-5">
                        <header>
                            <Title>
                                {lang.header.title.localize({emoji: '✅'})}
                            </Title>
                        </header>
                        <p className="leading-[1.8] max-w-[49ch]">
                            {lang.header.body}
                        </p>
                    </div>
                </div>
            </Hero>


            <div className="relative flex flex-col gap-9 md:gap-24">
                <SectionSteps className="accent-green-800" items={lang.application.list}>
                    <Title size="small">{lang.application.title.localize()}</Title>
                </SectionSteps>

                <SectionSteps className="accent-orange-800" items={lang.beforeStart.list}>
                    <Title size="small">{lang.beforeStart.title.localize()}</Title>
                </SectionSteps>

                <SectionSteps className="accent-purple-800" items={lang.firstDay.list}>
                    <Title size="small">{lang.firstDay.title.localize()}</Title>
                </SectionSteps>
            </div>

            <div className="relative pt-20 pb-24 md:py-24 flex flex-col items-center gap-16">
                <SectionRegisterCta cta={lang.register.cta}>
                    <Title className="max-w-[17ch] md:max-w-[26ch]">{lang.register.title.localize()}</Title>
                </SectionRegisterCta>
            </div>
        </MainLayout>
    )
}
